import { Box, Container, Link, Stack, Text, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { EmailIcon } from '@chakra-ui/icons' ;
import { FaTwitter, FaYoutube, FaLinkedin } from 'react-icons/fa';
import { SiGlassdoor } from 'react-icons/si';

import SocialButton from '../../../components/sections/socialbutton';

export default function SmallCentered() {
  return (
    <Box
      width="100%"
      bg="#333"
      color="white">
      <Container
        as={Stack}
        maxW="6xl"
        py={4}
        spacing={4}
        justify="center"
        align="center">
        <Stack direction="row" spacing={6}>
          <Link href="https://cscworkday.blob.core.windows.net/legal/policies/Applicant_and_Employee_Privacy_Notice.pdf" isExternal>Privacy Policy</Link>
          <Text>|</Text>
          <Link href="https://cscworkday.blob.core.windows.net/legal/policies/Cookie_Notice_Corporate_and_Recruiting_Site.pdf" isExternal>Cookie Notice</Link>
          <Text>|</Text>
          <Link href="/termsofuse">Terms of Use</Link>
          <Text>|</Text>
          <Link href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/Supply_Chain/Transparency_in_Supply_Chain_Statement.pdf" isExternal>Transparency in Supply Chain Statement</Link>
        </Stack>
      </Container>

      <Box>
        <Container
          as={Stack}
          maxW="6xl"
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}>
          <Text>© 2009-2023 Columbia Sportswear Company. All rights reserved.</Text>
          <Stack direction="column" align="center">
            <LinkBox>
              <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers/introduceYourself" isExternal>
                <Stack direction="row">
                  <EmailIcon boxSize={6}/>
                  <Text>STAY IN TOUCH</Text>
                </Stack>
              </LinkOverlay>
            </LinkBox>
            <Text>FOLLOW COLUMBIA SPORTSWEAR CO</Text>
            <Stack direction="row" spacing={6}>
              <SocialButton label="YouTube" href="https://www.youtube.com/user/ColumbiaSportswear">
                <FaYoutube size="40px" />
              </SocialButton>
              <SocialButton label="LinkedIn" href="https://www.linkedin.com/company/columbia-sportswear">
                <FaLinkedin size="40px" />
              </SocialButton>
              <SocialButton label="Twitter" href="https://twitter.com/ColumbiaCareers">
                <FaTwitter size="40px" />
              </SocialButton>
              <SocialButton label="GlassDoor" href="https://www.glassdoor.com/Jobs/Columbia-Sportswear-Jobs-E3853.htm">
                <SiGlassdoor size="36px" />
              </SocialButton>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
